module.exports = __webpack_public_path__ + "static/media/wssp-api.6651dab6.webp";